module.exports = __webpack_public_path__ + "c82388be068a782096bb97862a68a1a0.svg";